// extracted by mini-css-extract-plugin
export default {"nextAction":"NextButton_nextAction__xS0bU"};